import { PaginationState } from '@tanstack/react-table';
import { create } from 'zustand';

export interface PaginationStore {
  pagination: PaginationState;
  setPagination: (
    pagination: PaginationState | ((prev: PaginationState) => PaginationState),
  ) => void;
}

export const usePaginationStore = create<PaginationStore>((set, get) => ({
  pagination: { pageIndex: 0, pageSize: 50 },
  setPagination: (updater) => {
    set((state) => ({
      pagination:
        typeof updater === 'function' ? updater(state.pagination) : updater,
    }));
  },
  resetPagination: () => set({ pagination: { pageIndex: 0, pageSize: 5 } }),
}));
